module.exports = __webpack_public_path__ + "static/media/app-issue-view.aa1e23bd.jpg";